/**
 * Logic-free email template renderer (frontend mirror).
 *
 * MUST stay byte-identical in its render logic to
 * functions/emailTemplates/render.js so the editor's live preview matches
 * exactly what the Cloud Function will send. If you change substitution
 * semantics here, change them there too.
 *
 *   {{ a.b.c }}   -> escapeHtml(get(ctx, 'a.b.c'))   (auto-escaped, default)
 *   {{{ a.b.c }}} -> get(ctx, 'a.b.c') as raw HTML
 *
 * No conditionals or loops by design.
 */

export function escapeHtml(value) {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

export function getPath(context, path) {
  if (!context || typeof context !== 'object') return undefined;
  return String(path)
    .split('.')
    .reduce((acc, key) => (acc == null ? acc : acc[key]), context);
}

export function renderString(template, context, forceRaw = false) {
  if (typeof template !== 'string') return '';
  return template.replace(
    /\{\{\{\s*([\w.]+)\s*\}\}\}|\{\{\s*([\w.]+)\s*\}\}/g,
    (match, rawPath, escapedPath) => {
      const isRaw = forceRaw || rawPath !== undefined;
      const path = rawPath !== undefined ? rawPath : escapedPath;
      const value = getPath(context, path);
      const str = value === null || value === undefined ? '' : String(value);
      return isRaw ? str : escapeHtml(str);
    },
  );
}

export function renderTemplatePair({ subject, html }, context) {
  const renderedSubject = renderString(subject || '', context, true).replace(/<[^>]*>/g, '').trim();
  const renderedHtml = renderString(html || '', context);
  return { subject: renderedSubject, html: renderedHtml };
}
